export const useGlobalStore = defineStore({
  id: 'global',

  state: () => ({
    isMobileMenuShow: false,
  }),

  getters: {},

  actions: {
    openMobileMenu() {
      this.isMobileMenuShow = true;
    },

    closeMobileMenu() {
      this.isMobileMenuShow = false;
    },
  },
});
